<div class="row" [formGroup]="controlGroup">
  <input type="datetime-local" formControlName="gt" />
  <p>-</p>
  <input type="datetime-local" formControlName="lt" />
</div>
